mobileSize = 800;

$(document).ready(function () {
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 800) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 801) {
    $('body').removeClass('saffireMobileSize');
  }
  const fes1 = $('.subscribe-container .emailSignup ');
  fes1.find('.emailInputSubmit a').text('SIGN UP!');
  fes1.find('.inputFieldTextbox').val('');
  fes1.find('.inputFieldTextbox').attr('placeholder', 'Email Address');
  // General Message
  $('.generalmessage').prependTo('header');
  setInterval(function () {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (!weatherBugSet && str != '') {
      $('#weatherBugWidget').addClass('weatherBugSet');
      var findSpace = str.lastIndexOf(' ');
      var stringLength = str.length;
      var res = str.substring(findSpace, stringLength);
      var start = str.substring(0, findSpace);
      $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
      $('#weatherBugWidget').css('visibility', 'visible');
    }
  }, 12);
  $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
  
});

$(window).load(function () {
  $('body').addClass('pageIsLoaded');
});

